import { Navigate, Outlet, useLocation } from "react-router-dom";

import { LoadingState } from "@/components/feedback";
import { usePageViewBeacon } from "@/features/audit/usePageViewBeacon";
import { useAuth } from "./useAuth";

/**
 * Guarda de rota: usada como `<Route element={<RequireAuth />}>` envolvendo
 * todas as rotas protegidas (tudo menos `/login`). Fica montada durante toda
 * a navegação protegida (ela troca de filho via `<Outlet/>`, não desmonta a
 * cada rota), então é o lugar certo para o beacon de auditoria de página
 * (ver `usePageViewBeacon`) — ele reage a cada troca de `location.pathname`.
 */
export function RequireAuth() {
  const { isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  usePageViewBeacon();

  if (isLoading) {
    return <LoadingState label="Verificando sessão…" className="min-h-screen" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
